'use client';

import { c as _c } from "react/compiler-runtime";
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getPublicExternshipCatalog } from './get-public-externship-catalog';
const FIVE_MINUTES_MS = 5 * 60 * 1000;
export const publicExternshipCatalogQueryOptions = () => queryOptions({
  queryFn: getPublicExternshipCatalog,
  queryKey: ['externships', 'public-catalog'],
  refetchOnWindowFocus: false,
  retry: false,
  staleTime: FIVE_MINUTES_MS
});
export function usePublicExternshipCatalog() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = publicExternshipCatalogQueryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}